module.exports = __webpack_public_path__ + "media/images/area/area_kyotoM400-6543e1e4358ae01a00eec3c0992ff6ec.jpg";